import React, { useContext } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Avatar,
  Box,
} from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';
import { AuthContext } from '../auth/AuthContext';
import NotificheBadge from './NotificheBadge';
import { useNavigate } from 'react-router-dom';

export default function TopBar() {
  const { user, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const APP_VERSION = process.env.REACT_APP_VERSION;
  const firstLetter = user?.username ? user.username.charAt(0).toUpperCase() : '?';

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <AppBar
      position="fixed"
      sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
    >
      <Toolbar sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <Typography variant="h6">DeskStudio
          <Typography
            component="span"
            sx={{ ml: 1, fontSize: '0.75rem', opacity: 0.7 }}
          >
            v{APP_VERSION}
          </Typography>
          </Typography>
                    <NotificheBadge />
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <Typography>
            {user?.nomecognomeutente} ({user?.role || '-'}) {user?.role==='STUDIO'?'Codice invito: '+user?.codiceInvito:''}
          </Typography>
          <Avatar>{firstLetter}</Avatar>

          <IconButton color="inherit" onClick={handleLogout}>
            <LogoutIcon />
          </IconButton>

        </Box>
      </Toolbar>
    </AppBar>
  );
}